import moment from 'moment'

const ptBrLocale = require('moment/locale/pt-br')

moment.updateLocale('pt-br', ptBrLocale)

function capitalize(text) {
  return text.charAt(0).toUpperCase() + text.slice(1)
}

export default function getDayOfWeek(date) {
  if (!date) {
    return null
  }
  let dayOfWeek = moment(date)
    .locale('pt-br')
    .format('dddd')

  return capitalize(dayOfWeek)
}
